import { render, staticRenderFns } from "./FlashCard1.vue?vue&type=template&id=6746bde2&scoped=true&"
import script from "./FlashCard1.vue?vue&type=script&lang=js&"
export * from "./FlashCard1.vue?vue&type=script&lang=js&"
import style0 from "./FlashCard1.vue?vue&type=style&index=0&id=6746bde2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6746bde2",
  null
  
)

export default component.exports